// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file reports/overview.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ComparisionItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.OverviewReportRequest
 */
export class OverviewReportRequest extends Message<OverviewReportRequest> {
  /**
   * Start date for the report (timestamp)
   *
   * @generated from field: int32 start_date = 1;
   */
  startDate = 0;

  /**
   * End date for the report (timestamp)
   *
   * @generated from field: int32 end_date = 2;
   */
  endDate = 0;

  constructor(data?: PartialMessage<OverviewReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.OverviewReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "end_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OverviewReportRequest {
    return new OverviewReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OverviewReportRequest {
    return new OverviewReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OverviewReportRequest {
    return new OverviewReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: OverviewReportRequest | PlainMessage<OverviewReportRequest> | undefined, b: OverviewReportRequest | PlainMessage<OverviewReportRequest> | undefined): boolean {
    return proto3.util.equals(OverviewReportRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.OverviewReportResponse
 */
export class OverviewReportResponse extends Message<OverviewReportResponse> {
  /**
   * Total sales for the period
   *
   * @generated from field: com.neulink.pharmacy.ComparisionItem total_sales = 1;
   */
  totalSales?: ComparisionItem;

  /**
   * Total discounts given for the period
   *
   * @generated from field: com.neulink.pharmacy.ComparisionItem total_discounts_given = 2;
   */
  totalDiscountsGiven?: ComparisionItem;

  /**
   * Total refunded sales for the period
   *
   * @generated from field: com.neulink.pharmacy.ComparisionItem total_refunded_sales = 3;
   */
  totalRefundedSales?: ComparisionItem;

  /**
   * Indicates if the next supplier payment is due
   *
   * @generated from field: bool is_next_supplier_payment_due = 4;
   */
  isNextSupplierPaymentDue = false;

  /**
   * Date when the next supplier payment is due
   *
   * @generated from field: google.protobuf.Timestamp next_supplier_payment_due_date = 5;
   */
  nextSupplierPaymentDueDate?: Timestamp;

  /**
   * ID of the supplier for the next payment
   *
   * @generated from field: string next_supplier_payment_supplier_id = 6;
   */
  nextSupplierPaymentSupplierId = "";

  /**
   * Name of the supplier for the next payment
   *
   * @generated from field: string next_supplier_payment_supplier_name = 7;
   */
  nextSupplierPaymentSupplierName = "";

  constructor(data?: PartialMessage<OverviewReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.OverviewReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_sales", kind: "message", T: ComparisionItem },
    { no: 2, name: "total_discounts_given", kind: "message", T: ComparisionItem },
    { no: 3, name: "total_refunded_sales", kind: "message", T: ComparisionItem },
    { no: 4, name: "is_next_supplier_payment_due", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "next_supplier_payment_due_date", kind: "message", T: Timestamp },
    { no: 6, name: "next_supplier_payment_supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "next_supplier_payment_supplier_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OverviewReportResponse {
    return new OverviewReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OverviewReportResponse {
    return new OverviewReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OverviewReportResponse {
    return new OverviewReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: OverviewReportResponse | PlainMessage<OverviewReportResponse> | undefined, b: OverviewReportResponse | PlainMessage<OverviewReportResponse> | undefined): boolean {
    return proto3.util.equals(OverviewReportResponse, a, b);
  }
}

